import '../estilo/inicio.scss'
import * as comun from './modulos/comun'
import articulus from './modulos/articulus'
import * as articulos from './modulos/articulos'

comun.registrarServiceWorker().catch(error => { console.error(error) })
comun.chorrear(() => {
  comun.iniciarMenu('mnuInicio')
})
const isoIdioma = comun.obtenerIdiomaUrl()
comun.setIdiomaPagina()

// Promo con contenido de API Chorro
articulus(`${comun.urlBaseApi}/apis/chorro/v1/?chorro=appPromoHome`, isoIdioma).then(chorro => {
  if (chorro.appPromoHome) {
    document.querySelector('.promoHome .contenedor').innerHTML = chorro.appPromoHome
    document.querySelector('.promoHome').classList.remove('oculto')
  }
}).catch(error => { console.error(error) })

// Artículos de promo
articulos.iniciar(document.querySelector('.plantilla.artiPromo'), document.querySelector('.artisPromo'), {
  idioma: isoIdioma,
  seccion: 'blog_orsai_' + isoIdioma,
  orden: 'crono',
  ordelDir: 'desc',
  pagina: 1,
  cantidad: 20,
  categoria: 'novedades'
})
